import { getTranslatedString } from 'helpers/i18n';
import { useState } from 'react';

const defaultOnPaymentTokenizeError = (error) => {};
const defaultOnPaymentTokenizeSuccess = (result, paymentDetails) => {
  console.info('[Paysafe] Successful payment', result, paymentDetails);
};

const usePaysafe = ({
  paymentForm,
  onPaymentTokenizeSuccess = defaultOnPaymentTokenizeSuccess,
  onPaymentTokenizeError = defaultOnPaymentTokenizeError,
}) => {
  const [isPaying, setIsPaying] = useState(false);
  const [paysafeInstance, setPaysafeInstance] = useState();
  const [cardNumberError, setCardNumberError] = useState('');
  const [cvvError, setCvvError] = useState('');
  const [expiryDateError, setExpiryDateError] = useState('');
  const [paymentError, setPaymentError] = useState();

  const submitPayment = async () => {
    const paymentDetails = await paymentForm.validateFields();

    try {
      if (!paysafeInstance) {
        setPaymentError('Issue processing payment');
        window.Rollbar.error('No paysafe instance');
        throw Error;
      }

      setIsPaying(true);

      paysafeInstance.tokenize(async (instance, error, result) => {
        if (error) {
          if (error.fieldErrors) {
            error.fieldErrors.forEach((error) => {
              if (error.field === 'card number') {
                this.setCardNumberError(
                  getTranslatedString('tenantPortal.paysafe.invalidCardNumber')
                );
              }
              if (error.field === 'cvv') {
                this.setCvvError(getTranslatedString('tenantPortal.paysafe.invalidCVVNumber'));
              }
              if (error.field === 'expiry date') {
                this.setExpiryDateError(getTranslatedString('tenantPortal.paysafe.invalidDate'));
              }
            });
          } else {
            setPaymentError('Your payment was not successful. Please check your card information');
          }
          window.Rollbar.error('Tokenization error: ' + error.code + ' ' + error.detailedMessage);
          onPaymentTokenizeError(error);
          setIsPaying(false);
        } else {
          console.log({ token: result.token, payment_details: paymentDetails });
          await onPaymentTokenizeSuccess(result, paymentDetails);
          setIsPaying(false);
        }
      });
    } catch (error) {
      setPaymentError('Your payment was not successful. Please check your card information');
      setIsPaying(false);
      onPaymentTokenizeError(error);
    }
  };

  return {
    isPaying,
    paysafeInstance,
    cardNumberError,
    cvvError,
    expiryDateError,
    paymentError,
    setIsPaying,
    setPaysafeInstance,
    setCardNumberError,
    setCvvError,
    setExpiryDateError,
    setPaymentError,
    submitPayment,
  };
};

export default usePaysafe;
